/**
 * @generated SignedSource<<8abd40a1021f23fc41ffb2501960e820>>
 * @relayHash 6a0ddf193b7fe99cd5e6ed9269b1f38f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4b34ab098b92b340a5e766bc8de22f118809be505333e52cbb6d0f60ecade42d

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceAppInstallationLicenseCapabilitySet = "CAPABILITY_ADVANCED" | "CAPABILITY_STANDARD" | "%future added value";
export type ConfluenceExtensionVisibilityControlMechanism = "APP_ACCESS_RULES" | "DISPLAY_CONDITIONS" | "%future added value";
export type ConfluenceExtensionRenderingContextInput = {
  attachmentId?: string | null;
  contentId?: AGG$Long | null;
  spaceId?: AGG$Long | null;
  spaceKey?: string | null;
};
export type preloadForgeApps_FetchPreFilteredForgeAppsQuery$variables = {
  cloudId: string;
  context?: ConfluenceExtensionRenderingContextInput | null;
  includeHidden?: boolean | null;
  includeSandboxPolicies?: boolean | null;
  locale?: string | null;
  types?: ReadonlyArray<string | null> | null;
};
export type preloadForgeApps_FetchPreFilteredForgeAppsQuery$data = {
  readonly confluence_forgeExtensionsByType: ReadonlyArray<{
    readonly appId: string;
    readonly appOwner: string | null;
    readonly appVersion: string | null;
    readonly consentUrl: string | null;
    readonly egress: ReadonlyArray<{
      readonly addresses: ReadonlyArray<string | null> | null;
      readonly category: string | null;
      readonly inScopeEUD: boolean | null;
      readonly type: string | null;
    }> | null;
    readonly environmentId: string;
    readonly environmentKey: string | null;
    readonly environmentType: string;
    readonly hiddenBy: ConfluenceExtensionVisibilityControlMechanism | null;
    readonly id: string;
    readonly installationId: string;
    readonly key: string;
    readonly license: {
      readonly active: boolean;
      readonly billingPeriod: string | null;
      readonly capabilitySet: ConfluenceAppInstallationLicenseCapabilitySet | null;
      readonly ccpEntitlementId: string | null;
      readonly ccpEntitlementSlug: string | null;
      readonly isEvaluation: boolean | null;
      readonly subscriptionEndDate: string | null;
      readonly trialEndDate: string | null;
      readonly type: string | null;
    } | null;
    readonly migrationKey: string | null;
    readonly properties: ReadonlyArray<{
      readonly key: string | null;
      readonly value: string | null;
    }>;
    readonly remoteInstallationRegion: string | null;
    readonly sandboxPolicies?: ReadonlyArray<string> | null;
    readonly scopes: ReadonlyArray<string | null>;
    readonly type: string;
    readonly userAccess: {
      readonly enabled: boolean | null;
      readonly hasAccess: boolean | null;
    } | null;
  } | null> | null;
};
export type preloadForgeApps_FetchPreFilteredForgeAppsQuery = {
  response: preloadForgeApps_FetchPreFilteredForgeAppsQuery$data;
  variables: preloadForgeApps_FetchPreFilteredForgeAppsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeHidden"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSandboxPolicies"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "types"
},
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = {
  "kind": "ScalarField",
  "name": "type"
},
v8 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "context",
        "variableName": "context"
      },
      {
        "kind": "Variable",
        "name": "includeHidden",
        "variableName": "includeHidden"
      },
      {
        "kind": "Variable",
        "name": "locale",
        "variableName": "locale"
      },
      {
        "kind": "Variable",
        "name": "types",
        "variableName": "types"
      }
    ],
    "concreteType": "ConfluenceForgeExtension",
    "kind": "LinkedField",
    "name": "confluence_forgeExtensionsByType",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "appId"
      },
      {
        "kind": "ScalarField",
        "name": "appVersion"
      },
      {
        "kind": "ScalarField",
        "name": "appOwner"
      },
      {
        "kind": "ScalarField",
        "name": "environmentId"
      },
      {
        "kind": "ScalarField",
        "name": "environmentType"
      },
      {
        "kind": "ScalarField",
        "name": "environmentKey"
      },
      {
        "kind": "ScalarField",
        "name": "consentUrl"
      },
      {
        "kind": "ScalarField",
        "name": "migrationKey"
      },
      {
        "concreteType": "ConfluenceUserAccess",
        "kind": "LinkedField",
        "name": "userAccess",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "enabled"
          },
          {
            "kind": "ScalarField",
            "name": "hasAccess"
          }
        ]
      },
      (v6/*: any*/),
      {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      },
      {
        "concreteType": "ConfluenceExtensionEgressDeclaration",
        "kind": "LinkedField",
        "name": "egress",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "addresses"
          },
          {
            "kind": "ScalarField",
            "name": "category"
          },
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "name": "inScopeEUD"
          }
        ]
      },
      {
        "condition": "includeSandboxPolicies",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "sandboxPolicies"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "scopes"
      },
      {
        "concreteType": "ConfluenceAppInstallationLicense",
        "kind": "LinkedField",
        "name": "license",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "active"
          },
          {
            "kind": "ScalarField",
            "name": "capabilitySet"
          },
          {
            "kind": "ScalarField",
            "name": "billingPeriod"
          },
          {
            "kind": "ScalarField",
            "name": "ccpEntitlementId"
          },
          {
            "kind": "ScalarField",
            "name": "ccpEntitlementSlug"
          },
          {
            "kind": "ScalarField",
            "name": "isEvaluation"
          },
          {
            "kind": "ScalarField",
            "name": "subscriptionEndDate"
          },
          {
            "kind": "ScalarField",
            "name": "trialEndDate"
          },
          (v7/*: any*/)
        ]
      },
      (v7/*: any*/),
      {
        "kind": "ScalarField",
        "name": "installationId"
      },
      {
        "kind": "ScalarField",
        "name": "remoteInstallationRegion"
      },
      {
        "kind": "ScalarField",
        "name": "hiddenBy"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "preloadForgeApps_FetchPreFilteredForgeAppsQuery",
    "selections": (v8/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "preloadForgeApps_FetchPreFilteredForgeAppsQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "6a0ddf193b7fe99cd5e6ed9269b1f38f",
    "id": "4b34ab098b92b340a5e766bc8de22f118809be505333e52cbb6d0f60ecade42d",
    "metadata": {},
    "name": "preloadForgeApps_FetchPreFilteredForgeAppsQuery",
    "operationKind": "query",
    "text": "query preloadForgeApps_FetchPreFilteredForgeAppsQuery($cloudId:ID!,$context:ConfluenceExtensionRenderingContextInput,$includeHidden:Boolean,$locale:String,$types:[String],$includeSandboxPolicies:Boolean=false){confluence_forgeExtensionsByType(cloudId:$cloudId,context:$context,includeHidden:$includeHidden,locale:$locale,types:$types){id,appId,appVersion,appOwner,environmentId,environmentType,environmentKey,consentUrl,migrationKey,userAccess{enabled,hasAccess},key,properties{key,value},egress{addresses,category,type,inScopeEUD},sandboxPolicies@include(if:$includeSandboxPolicies),scopes,license{active,capabilitySet,billingPeriod,ccpEntitlementId,ccpEntitlementSlug,isEvaluation,subscriptionEndDate,trialEndDate,type},type,installationId,remoteInstallationRegion,hiddenBy}}"
  }
};
})();

(node as any).hash = "054522a5678e631f94c42ca9dccf00f3";

export default node;
